<template>
<v-card elevation="0">
  <v-card-actions class="justify-center">
    <div class="d-flex align-center">
      <v-list-item class="pr-1">
        <v-list-item-content>
          <v-list-item-title class="text-h2">
            Neues Suchprofil erstellen
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-btn icon @click="onCancelEdit" >
        <v-icon>$vuetify.icons.clear</v-icon>
      </v-btn>
    </div>
  </v-card-actions>
<saved-search-wizard :contact-form="false" :show-steps="false" @save="onSave">
  <template v-slot:footer="{ save, isComplete }">
    <div class="text-center">
      <v-btn @click="save" color="primary" :disabled="!isComplete" :loading="loading" large class="mr-4">Speichern</v-btn>
      <v-btn @click="onCancelEdit" color="primary" outlined large>Abbrechen</v-btn>
    </div>
  </template>
</saved-search-wizard>
</v-card>
</template>

<script>
import SavedSearchWizard from "../wizard/SavedSearchWizard";

export default {
  name: "SavedSearchEdit",

  components: {
    SavedSearchWizard,
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    }
  },

  methods: {
    onSave(savedSearch) {
      this.$store.dispatch("contact/createSavedSearch", savedSearch).then(() => {
        this.$store.commit("userDialog", null);
      });
    },

    onCancelEdit() {
      this.$store.commit("userDialog", null);
    }
  }
};
</script>
